<template>
  <div id="redeem">
    <form name="redeem" @submit.prevent="redeem">
      <div class="form-group mb-0">
        <label for="codeString"><strong>Participation code</strong></label>
        
        <div class="input-group">
          <input type="text" name="codeString" id="codeString" class="form-control" v-model="codeString" placeholder="Enter participation code" aria-label="Enter participation code" aria-describedby="redeem-button">
          <div class="input-group-append">
            <button type="submit" class="btn btn-success" id="redeem-button" :disabled="loading || !codeString">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
              Join now!
            </button>
          </div>
        </div>
      </div>

      <div class="text-danger mt-2" v-if="error">
        {{ error }}
      </div>
    </form>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  export default {
    name: "redeem-form",
    props: {
      event: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        loading: false,
        codeString: null,
        error: null
      }
    },
    methods: {
      async redeem() {
        this.loading = true

        let codeRef = await firebase.firestore().collection(`codes`).doc(this.codeString)
        let ticket = await codeRef.get()
        let ticketData = await ticket.data()

        if(ticket.exists && ticketData.eventId == this.event.id) {
          await codeRef.update({ currentUser: this.$store.state.currentUser.uid, used: true })
          let codeObject = {}
          codeObject[this.event.id] = { codeString: ticket.id }
          
          await this.$store.commit("setCurrentCode", codeObject)

          this.loading = false
          this.codeString = null
        } else {
          this.error = "Participation code was not found or is invalid"
          this.loading = false
        }
      }
    }
  }
</script>